import { render, staticRenderFns } from "./ApexPieChart.vue?vue&type=template&id=e3b23600&"
import script from "./ApexPieChart.vue?vue&type=script&lang=js&"
export * from "./ApexPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports